import { render } from "./ProductContainer.vue?vue&type=template&id=7ad94823&scoped=true"
import script from "./ProductContainer.vue?vue&type=script&lang=js"
export * from "./ProductContainer.vue?vue&type=script&lang=js"

import "./ProductContainer.vue?vue&type=style&index=0&id=7ad94823&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad94823"]])

export default __exports__